import React from "react"

export default class FormSubmit extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="row">
				<div className="col-sm-12">
					<div className="FormSubmit">
						<button type="submit" className={"btn btn-primary " + (this.props.disabled ? 'btn-disabled' : '')} disabled={this.props.disabled}>{this.props.text || 'Create Account'}</button>
					</div>
				</div>
			</div>
		);	
	}

}